import vueDebounce from 'vue-debounce';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBook,
  faCopy,
  faPen,
  faQuestionCircle,
  faSearch,
  faTimes,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faBook,
  faCheckSquare,
  faCopy,
  faPen,
  faQuestionCircle,
  faSearch,
  faSquare,
  faTimes,
  faTimesCircle,
);

export * from './components';

const install = (Vue) => {
  Vue.use(BootstrapVue);
  Vue.use(vueDebounce);
  Vue.component('font-awesome-icon', FontAwesomeIcon);

  // Register a global custom directive called `v-focus`
  Vue.directive('focus', {
    inserted: function (el, binding) {
      if (binding.value === undefined || binding.value) {
        setTimeout(() => {
          el.focus();
        }, 300);
      }
    },
  });
};

export default {
  install,
};
